import { Box, Flex, Text, useColorMode } from '@chakra-ui/react';
import { IProgressOptions } from 'ms-react-progress-bar/dist/models/models';
import CodeBlock from '../CodeBlock';
import { bgColor, borderColor } from '../const';
interface ICustomOptionsProps {
	options: IProgressOptions;
	progressValue: number;
}

export const CustomOptions = ({ options, progressValue }: ICustomOptionsProps) => {
	const { colorMode } = useColorMode();

	const progressOptions: IProgressOptions = { ...options };

	if (progressOptions.type === 'regular') delete progressOptions.type;
	if (progressOptions.containerStyle === 'bg') delete progressOptions.containerStyle;
	if (progressOptions.maxValue === 100) delete progressOptions.maxValue;
	if (progressOptions.labelVisibility === true) delete progressOptions.labelVisibility;
	if (progressOptions.labelAlignment === 'left') delete progressOptions.labelAlignment;
	if (progressOptions.stripeAnimation === false) delete progressOptions.stripeAnimation;
	if (progressOptions.stripeAnimationDuration === '10s') delete progressOptions.stripeAnimationDuration;
	if (
		progressOptions.labelColor === '#ffffff' ||
		progressOptions.labelColor === 'white' ||
		progressOptions.labelColor === '#fff'
	)
		delete progressOptions.labelColor;
	if (progressOptions.stripeAnimationDuration === '10s') delete progressOptions.stripeAnimationDuration;
	if (progressOptions.showMaxValue === false) delete progressOptions.showMaxValue;
	if (progressOptions.labelPosition === "center") delete progressOptions.labelPosition;

	return (
		<Box w="100%">
			<Text my="20px">Custom Options</Text>
			<Box border="1px" borderColor={borderColor[colorMode]} borderRadius="xs" p="10px" bg={bgColor[colorMode]}>
				<Flex alignItems="center">
					<Box w="35%">
						const options = {'{'}
						{Object.entries(progressOptions).map(([key, value]: any, index) => (
							<Box key={`${key}${index}`}>
								{!!value.toString() ? (
									<Text ml={6} fontSize="13px">
										<Text as="span" color="#68bb44">
											{key}
										</Text>
										{`: ${isNaN(value as number) ? `"${value}"` : value},`}
									</Text>
								) : (
									undefined
								)}
							</Box>
						))}
						{'};'}
					</Box>
					<Box w="65%">
						<CodeBlock language="jsx" text={`<ProgressBar value={${progressValue}} options={options} />`} />
					</Box>
				</Flex>
			</Box>
		</Box>
	);
};
